import type { InterviewType } from '@/types/interview';

type AiFillGateInput =
  | Pick<InterviewType, 'transcript_status' | 'fill_with_ai_enabled'>
  | null
  | undefined;

/**
 * Whether the Fill-with-AI header may show for this interview.
 *
 * The header used to be gated on the transcript alone, so turning off "Allow
 * interviewers to complete scorecards with AI" hid nothing and every interview
 * with a transcript still offered AI fill (ENG-3791).
 *
 * `fill_with_ai_enabled` is the server-resolved account + per-activity setting.
 * Only an explicit `false` hides the action — a missing flag stays enabled so
 * responses predating it behave as they do today.
 */
export const canFillScorecardWithAi = (interview: AiFillGateInput): boolean =>
  interview?.transcript_status === 'completed' &&
  isAiScorecardFillEnabled(interview);

/**
 * The setting on its own, for surfaces that decide "is there a transcript"
 * differently — the collect-scorecard drawers look at transcript *content*
 * rather than status, but must honour the same setting.
 */
export const isAiScorecardFillEnabled = (
  interview: Pick<InterviewType, 'fill_with_ai_enabled'> | null | undefined
): boolean => interview?.fill_with_ai_enabled !== false;
